export default __webpack_public_path__ + "static/media/cube.f03d2d11.usdz";